import api from './api';

/**
 * Save for Later Service
 * Handles API calls for saving policy drafts
 */
export const saveForLaterService = {
    /**
     * Save policy draft
     * @param {Object} draftData - The prepared policy draft data
     * @returns {Promise} API response
     */
    saveDraft: async (draftData) => {
        try {
            console.log('📋 Saving policy draft with data:', draftData);

            const response = await api.post('/policy/draft', draftData);

            console.log('✅ Draft saved successfully:', response.data);
            return {
                success: true,
                data: response.data?.data,
                message: response.data?.message || 'Draft saved successfully',
            };
        } catch (error) {
            console.error('❌ Error saving draft:', error);

            return {
                success: false,
                error: error.response?.data?.message || error.message,
                message: 'Failed to save draft',
            };
        }
    },

    /**
     * Get all saved drafts for a customer
     * @param {number|string} customerId - The customer ID
     * @returns {Promise} API response with drafts
     */
    getDrafts: async (customerId) => {
        try {
            const response = await api.get(`/policy/draft?customer_id=${customerId}`);

            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            console.error('❌ Error fetching drafts:', error);

            return {
                success: false,
                error: error.response?.data?.message || error.message,
            };
        }
    },

    /**
     * Get a specific draft by ID
     * @param {number|string} draftId - The draft ID
     * @returns {Promise} API response
     */
    getDraftById: async (draftId) => {
        try {
            const response = await api.get(`/policy/draft/${draftId}`);

            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            console.error('❌ Error fetching draft:', error);

            return {
                success: false,
                error: error.response?.data?.message || error.message,
            };
        }
    },

    /**
     * Delete a saved draft
     * @param {number|string} draftId - The draft ID to delete
     * @returns {Promise} API response
     */
    deleteDraft: async (draftId) => {
        try {
            const response = await api.delete(`/policy/draft/${draftId}`);

            return {
                success: true,
                data: response.data,
                message: 'Draft deleted successfully',
            };
        } catch (error) {
            console.error('❌ Error deleting draft:', error);

            return {
                success: false,
                error: error.response?.data?.message || error.message,
            };
        }
    },

    /**
     * Update an existing draft
     * @param {number|string} draftId - The draft ID
     * @param {Object} draftData - Updated draft data
     * @returns {Promise} API response
     */
    updateDraft: async (draftId, draftData) => {
        try {
            console.log('📋 Updating policy draft:', draftId);

            const response = await api.put(`/policy/draft/${draftId}`, draftData);

            console.log('✅ Draft updated successfully:', response.data);
            return {
                success: true,
                data: response.data,
                message: 'Draft updated successfully',
            };
        } catch (error) {
            console.error('❌ Error updating draft:', error);

            return {
                success: false,
                error: error.response?.data?.message || error.message,
                message: 'Failed to update draft',
            };
        }
    },
};
